import { useNavigate } from '@tanstack/react-router'
import ArrowRight from 'assets/arrow-right.svg?react'
import CantileverButton from 'components/CantileverButton'
import { RiskBadge } from 'features/fde'
import React from 'react'
import styled from 'styled-components'
import { GeckoRiskAssessment, GeckoRiskAssessmentConfig } from 'types'

const RiskBadgeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
`

const RiskLabelText = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.secondaryText};
`

interface RiskLabelProps {
  riskAssessmentConfig: GeckoRiskAssessmentConfig
  latestRiskAssessment: GeckoRiskAssessment | undefined
  siteID: string
  unitID: string
}

export const RiskLabel: React.FC<RiskLabelProps> = ({
  riskAssessmentConfig,
  latestRiskAssessment,
  siteID,
  unitID,
}) => {
  const navigate = useNavigate()

  const handleRiskBadgeClick = () => {
    navigate({
      to: '/asset-assessment/$siteID/$unitID',
      params: {
        siteID: siteID,
        unitID: unitID,
      },
    })
  }

  return (
    <RiskBadgeContainer>
      <RiskLabelText>Current Risk:</RiskLabelText>
      {latestRiskAssessment?.data.current_risk !== undefined &&
      latestRiskAssessment?.data.current_risk !== 0 ? (
        <RiskBadge
          riskValue={latestRiskAssessment?.data.current_risk}
          riskAssessmentConfig={riskAssessmentConfig}
          onClick={handleRiskBadgeClick}
        />
      ) : (
        <CantileverButton onClick={handleRiskBadgeClick}>
          Assess{' '}
          <ArrowRight
            style={{
              width: 16,
              height: 16,
              verticalAlign: 'middle',
            }}
          />
        </CantileverButton>
      )}
    </RiskBadgeContainer>
  )
}
